export default __webpack_public_path__ + "static/media/cpics.f032cd05.jpg";